export enum LocalStorageKey {
  LastPayment = 'LastPayment',
  DoctorBookmark = 'DoctorBookmark',
  HospitalBookmark = 'HospitalBookmark',
  i18nLanguage = 'i18nLanguage',
  // LastLeaveTime = 'LastLeaveTime',
  broswerFlag = 'broswerFlag',
  deviceId = 'deviceId',
}

type Key = LocalStorageKey | `${LocalStorageKey}`;

class LocalStorageService {
  set(key: Key, item: string) {
    localStorage.setItem(key, item);
  }

  get(key: Key) {
    return localStorage.getItem(key);
  }

  remove(key: Key) {
    localStorage.removeItem(key);
  }

  clear() {
    localStorage.clear();
  }

  getKeyByIndex(index: number) {
    return localStorage.key(index);
  }
}

export const localStorageService = new LocalStorageService();
